import React, { useMemo } from 'react';
import { MemoChart } from './MemoChart';
import { useThemeVersion } from '../../../useTheme';

const formatDate = (value) => {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString('pt-BR');
};

export const SimuladoScoreTrendChart = ({ data }) => {
    const themeVersion = useThemeVersion();

    const chartData = useMemo(() => ({
        labels: (data || []).map(d => formatDate(d.completedAt)),
        datasets: [{
            label: 'Score',
            data: (data || []).map(d => d.score),
            borderColor: '#42A5F5',
            backgroundColor: '#42A5F5',
            borderWidth: 2,
            pointRadius: 4,
            tension: 0.4,
        }],
    }), [data]);

    const chartOptions = useMemo(() => {
        const textColor = getComputedStyle(document.documentElement).getPropertyValue('--text-color');
        const gridColor = getComputedStyle(document.documentElement).getPropertyValue('--surface-border');
        return {
            maintainAspectRatio: false,
            layout: { padding: 12 },
            plugins: {
                legend: { display: false },
                tooltip: {
                    callbacks: {
                        label: (context) => `Score: ${context.raw}%`,
                    },
                },
            },
            scales: {
                x: {
                    ticks: { color: textColor },
                    grid: { color: gridColor },
                },
                y: {
                    min: 0,
                    max: 100,
                    ticks: { color: textColor },
                    grid: { color: gridColor },
                },
            },
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [themeVersion]);

    if (!data || data.length === 0) return null;

    return (
        <MemoChart type="line" data={chartData} options={chartOptions} style={{ height: '260px' }} />
    );
};
